import type { TError } from '@onesource/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';

/**
 * Hook to delete a post
 * Only the post author can delete their own posts
 *
 * @param postId - Post ID (UUID) to delete
 */
export const useDeletePost = (postId: string) => {
  const queryClient = useQueryClient();

  return useMutation<void, TError, void>({
    mutationFn: async () => {
      await axios.delete(`/community-hub/posts/${postId}`);
    },
    onSuccess: () => {
      // Invalidate all posts queries to refresh the feed
      queryClient.invalidateQueries({ queryKey: [ENTITY, 'posts'] });
    },
  });
};
